import { Controller } from "stimulus"

// #1996: Mijn Training. De tabbladen wisselen zonder te herladen en staan in de
// url (?mt_tab=), de periodekeuze ververst de frame mt-statistieken, en het
// venster Schema toevoegen laadt pas als het opengaat.
export default class extends Controller {
  static targets = ["tab", "paneel", "venster", "toevoegenFrame", "bevestig", "bevestigTekst", "bevestigForm", "periodeForm", "tooltip"]

  kiesTab(event) {
    const naam = event.currentTarget.dataset.mtTab
    this.tabTargets.forEach((tab) => {
      const actief = tab.dataset.mtTab === naam
      tab.classList.toggle("is-actief", actief)
      tab.setAttribute("aria-selected", actief ? "true" : "false")
    })
    this.paneelTargets.forEach((paneel) => { paneel.hidden = paneel.dataset.paneel !== naam })

    const url = new URL(window.location.href)
    if (naam === "statistieken") {
      url.searchParams.delete("mt_tab")
    } else {
      url.searchParams.set("mt_tab", naam)
    }
    window.history.replaceState(window.history.state, "", url.toString())
  }

  kiesPeriode() {
    this.periodeFormTarget.requestSubmit()
  }

  openToevoegen() {
    const frame = this.toevoegenFrameTarget
    if (!frame.getAttribute("src")) frame.setAttribute("src", frame.dataset.bron)
    this.vensterTarget.showModal()
  }

  vraagVerwijderen(event) {
    const knop = event.currentTarget
    this.bevestigFormTarget.action = knop.dataset.url
    this.bevestigTekstTarget.textContent = knop.dataset.tekst
    this.bevestigTarget.showModal()
  }

  annuleerVerwijderen() {
    this.bevestigTarget.close()
  }

  toonPunt(event) {
    if (!this.hasTooltipTarget) return

    const punt = event.currentTarget
    const tooltip = this.tooltipTarget
    const vak = tooltip.parentElement.getBoundingClientRect()
    const plek = punt.getBoundingClientRect()
    tooltip.replaceChildren(this.regel("strong", punt.dataset.week), this.regel("span", punt.dataset.volume))
    tooltip.hidden = false
    tooltip.style.left = `${plek.left - vak.left + plek.width / 2}px`
    tooltip.style.top = `${plek.top - vak.top}px`
  }

  verbergPunt() {
    if (this.hasTooltipTarget) this.tooltipTarget.hidden = true
  }

  regel(soort, tekst) {
    const element = document.createElement(soort)
    element.textContent = tekst
    return element
  }
}
